import { Stage } from './ApplicationConfig';

const STAGE_BY_HOST: Record<string, Stage> = {
  'admin.skin-seoul.work': Stage.PROD,
  'staging.admin.skin-seoul.work': Stage.STAGING,
  'dev.admin.skin-seoul.work': Stage.DEV,
};

/** Prod is deliberately absent: a local page borrowing a live store's backend is never a dev convenience. */
const LENDABLE_BACKENDS: Record<string, Stage> = {
  local: Stage.LOCAL,
  dev: Stage.DEV,
  staging: Stage.STAGING,
};

/** Which environment this page *is* — decided by its domain, and by nothing else. */
export const resolveStage = (hostname: string): Stage => STAGE_BY_HOST[hostname] ?? Stage.LOCAL;

/**
 * Which environment's backend it talks to. Only a local page can borrow another one's, which is how
 * `STAGE=dev npm run dev` lets the UI be worked on against real dev data without a deploy round-trip.
 * The page stays local — its own stage decides sign-in — so only the API addresses change.
 */
export const resolveBackendStage = (hostname: string, override: string | undefined): Stage => {
  const stage = resolveStage(hostname);
  if (stage !== Stage.LOCAL) {
    return stage;
  }
  return LENDABLE_BACKENDS[(override ?? '').trim().toLowerCase()] ?? Stage.LOCAL;
};
